import React, { Component } from 'react'
import './album-common.css'
import Search from './search';
import Main from './main';

class AlbumContent extends Component {
    state = {
        searchName: ''
    }

    setSearchName = (searchName) => {
        // this.searchName = searchName
        this.setState({ searchName })
    }

    render() {
        return (
            <main role="main">
                <section className="jumbotron text-center">
                    <Search setSearchName={this.setSearchName} />
                </section>
                <div className="album py-5 bg-light">
                    <Main searchName={this.state.searchName} />
                </div>
            </main>
        )
    }
}

export default AlbumContent